<template>
  <v-container
    id="objects-list"
    :class="(isMobileView ? 'pt-2' : '') + ' pa-0'"
  >
    <HomeDesktopImagesSlider v-if="homepage && $vuetify.breakpoint.mdAndUp" />
    <v-bottom-navigation
      v-if="
        isMobileView && (!homepage || scrolledTop > 600) && !showMapOnMobile
      "
      fixed
    >
      <v-container class="pa-0">
        <ListTopFilters />
      </v-container>
    </v-bottom-navigation>
    <ListTopFilters v-else-if="!homepage" />
    <MobileFiltersPlaceholder />
    <v-dialog
      v-if="isMobileView"
      v-model="showMapOnMobile"
      fullscreen
    >
      <v-container
        class="white pa-0"
        :style="{ position: 'relative' }"
      >
        <v-row>
          <v-col class="pb-0">
            <ListMap
              v-if="$store.state.googleMapsLoaded"
              :height="$store.state.windowHeight - 0"
            />
          </v-col>
          <v-btn
            v-if="
              !($store.state.mapObjectDialog && $store.state.selectedMapObject)
            "
            class="csr-btn-color mt-4 mb-2 elevation-2"
            :style="{
              position: 'absolute',
              bottom: '40px',
              left: '50%',
              marginLeft: '-12px',
            }"
            fab
            dark
            small
            @click="showMapOnMobile = false"
          >
            <v-icon large>close</v-icon>
          </v-btn>
        </v-row>
      </v-container>
    </v-dialog>
    <v-row
      v-if="googleIsLoaded && !homepage && searchResult.length && isDesktopView"
    >
      <v-col class="pt-0">
        <ListMap v-if="$store.state.googleMapsLoaded" />
      </v-col>
    </v-row>
    <v-row
      dense
      :style="isMobileView ? 'margin-top: -10px !important;' : ''"
    >
      <ListObject
        v-for="(object, index) in searchResult"
        :key="index"
        :object="object"
      />
      <span
        v-if="searchResult && searchResult.length === 0"
        class="px-5"
      >
        <h1>
          <b>{{ $t('objekte_ei_leitud') }}</b>
        </h1>
      </span>
    </v-row>
    <ListPagination />
  </v-container>
</template>

<script>
import sharedMethods from '../../methods/sharedMethods'
import HomeDesktopImagesSlider from '@/components/Views/Home/HomeDesktopImagesSlider'
import sharedComputed from '@/methods/sharedComputed'
import MobileFiltersPlaceholder from '@/components/List/MobileFiltersPlaceholder'
import ListPagination from '@/components/List/ListPagination'
import ListObject from '@/components/List/ListObject/ListObject'

import { createHelpers } from 'vuex-map-fields'
import state from '../../store/state.js'
import ListTopFilters from '@/components/List/ListTopFilters'
import ListMap from '@/components/List/ListMap.vue'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'List',

  data() {
    return {
      // filtersOffsetTop: 0,
      googleIsLoaded: false,
    }
  },

  components: {
    ListMap,
    ListTopFilters,
    ListObject,
    ListPagination,
    MobileFiltersPlaceholder,
    HomeDesktopImagesSlider,
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,
  },

  created() {
    this.checkGoogleLoaded()
    this.$store.state.mapObjectDialog = false
    this.$store.state.selectedMapObject = null
  },

  watch: {
    sortBy() {
      if (this.searchFilters.page !== 1) {
        this.searchFilters.page = 1
      } else {
        this.searchObjects(true)
      }
    },
    page() {
      // Scroll to top first, otherwise scroll to search position
      // not working on Android
      // For mobile this happens inside searchObjects
      if (this.$vuetify.breakpoint.smAndDown) {
        window.scrollTo(0, 0)
      }
      this.$nextTick(() => {
        this.searchObjects(!this.homepage)
        // Always scroll instantly, otherwise Safari issues
        if (!this.$vuetify.breakpoint.smAndDown) {
          window.scrollTo({
            top: 0,
            left: 0,
            // behavior: 'smooth'
          })
        }
      })
    },
  },

  methods: {
    ...sharedMethods,

    checkGoogleLoaded() {
      console.log('checkGoogleLoaded', typeof google)
      if (typeof google !== 'undefined') {
        this.googleIsLoaded = true
      } else {
        setTimeout(() => {
          this.checkGoogleLoaded()
        }, 50)
      }
    },
  },
}
</script>
